const c_pathname = document.location.pathname.substr(1).toLowerCase().split("/")[1];
// console.log(c_pathname);
var url_string = window.location.href;
var url = new URL(url_string);

const socket = "";
const URLsocket = '';
//const URLBunge = 'https://server.omnion.com.br:10024';
// const URLBunge = 'http://apiminhabunge.handson-ti.com/omnion/';
// const URLBungeAvatar = 'https://www.minhabunge.com.br/avatar/';

//URL DEV: http://192.168.18.46:56241
//URL HOMOL: https://apiminhabunge.handson-ti.com/omnion/
//URL PROD: https://api.minhabunge.com.br/omnion


const URLBunge = 'https://api.minhabunge.com.br/omnion';
const URLBungeAvatar = 'https://www.minhabunge.com.br/avatar/';

var roomId = c_pathname;
const chat = "";

export {
    socket,
    URLsocket,
    chat,
    c_pathname,
    URLBunge,
    URLBungeAvatar
};